import { classMap as x } from "lit/directives/class-map.js";
import { unsafeStatic as o, literal as u, html as s } from "lit/static-html.js";
import { getCustomElementSuffix as $ } from "../../api/custom-element-scope.js";
import { MONTH as D, WEEK as A } from "./calendar.js";
const S = u`dss-timepicker${o($())}`, c = u`dss-icon${o($())}`, d = u`dss-icon-button${o($())}`, _ = u`dss-button${o($())}`, L = (e) => {
  var y, h, f, b;
  return s`
  <div
    class=${x({
    calendar__container: !0,
    "calendar__container--standalone": e.standalone
  })}
    @keydown="${e._handleCalendarKeydown}"
  >
    <div class="calendar__content">
      <div class="calendar__header">
        <div class="calendar__header-item calendar__header-selector">
          <div
            id="firstCalendarElement"
            class="calendar__header-item calendar__header-item--click calendar__header-month"
            tabindex="0"
            role="button"
            @keydown="${e._onHeaderMonthKeyDown}"
            @click="${e._toggleMonthSelector}"
            aria-label="selecciona el mes, actualment ${D[e._currMonth]}"
          >
            ${D[e._currMonth]}
            <${c} icon="expand_more" size="sm"></${c}>
          </div>
          <div
            class="calendar__header-item calendar__header-item--click calendar__header-year"
            tabindex="0"
            role="button"
            @keydown="${e._onHeaderYearKeyDown}"
            @click=${e._toggleYearSelector}
            aria-label="selecciona l'any, actualment ${e._currYear}"
          >
            ${e._currYear}
            <${c} icon="expand_more" size="sm"></${c}>
          </div>
        </div>
        <div class="calendar__header-item calendar__header-buttons">
          <${d} hideTooltip variant="primary" icon="chevron_left" label="Anterior" @click=${e._prev}
            ?disabled=${e._currMonth === ((y = e._minDate) == null ? void 0 : y.getMonth()) && e._currYear === ((h = e._minDate) == null ? void 0 : h.getFullYear())}>
          </${d}>
          <${d} hideTooltip variant="primary" icon="chevron_right" label="Següent" @click=${e._next}
            ?disabled=${e._currMonth === ((f = e._maxDate) == null ? void 0 : f.getMonth()) && e._currYear === ((b = e._maxDate) == null ? void 0 : b.getFullYear())}>
          </${d}>
        </div>
      </div>

      <div class="calendar__days-content">
        <ul class="calendar__week-names">
          ${A.map((t) => s`<li>${t}</li>`)}
        </ul>
        <div
          class="calendar__days"
          @mouseleave=${e._removeRangeOverDate}
        >
          ${e._days.map((t) => {
    if (!t)
      return s`
                <span class="calendar__day-item calendar__day-item--empty" aria-hidden="true"></span>
              `;
    const T = {
      "calendar__day-item--active": e._isToday(t),
      "calendar__day-item--weekend": e._isWeekend(t),
      "calendar__day-item--selected": e._isSelected(t),
      [`calendar__day-item--${e._getCustomType(t)}`]: !!e._getCustomType(t),
      "calendar__day-item--range": e._isBetweenRange(t) || e._isBetweenRangeOnMouseOver(t),
      "calendar__day-item--selected-range-start": e._isSelectedRangeStart(t),
      "calendar__day-item--selected-range-end": e._isSelectedRangeEnd(t) || e._isOverRangeDate(t),
      "calendar__day-item--range-enabled": e._range
    }, R = (a) => {
      const l = a.target;
      if (a.key === "ArrowUp") {
        a.preventDefault();
        const r = k(l, -7);
        r ? r.focus() : g();
      }
      if (a.key === "ArrowDown") {
        a.preventDefault();
        const r = k(l, 7);
        r ? r.focus() : m();
      }
      if (a.key === "ArrowRight") {
        a.preventDefault();
        const r = l.nextElementSibling;
        r ? r.focus() : m();
      }
      if (a.key === "ArrowLeft") {
        a.preventDefault();
        const r = B(l);
        r ? r.focus() : g();
      }
    }, g = () => {
      e._prev(), setTimeout(() => {
        var i;
        const a = (i = e.shadowRoot) == null ? void 0 : i.querySelectorAll(
          ".calendar__day-item:not(.calendar__day-item--empty)"
        ), l = Array.from(a).filter((n) => !n.disabled), r = l[l.length - 1];
        r && (r.setAttribute("tabindex", "0"), r.focus());
      }, 0);
    }, m = () => {
      e._next(), setTimeout(() => {
        var i;
        const a = (i = e.shadowRoot) == null ? void 0 : i.querySelectorAll(
          ".calendar__day-item:not(.calendar__day-item--empty)"
        ), r = Array.from(a).filter((n) => !n.disabled)[0];
        r && (r.setAttribute("tabindex", "0"), r.focus());
      }, 0);
    }, B = (a) => {
      let l = a == null ? void 0 : a.previousElementSibling;
      for (; l; ) {
        if (!l.classList.contains("calendar__day-item") || l.classList.contains("calendar__day-item--empty")) {
          l = l.previousElementSibling;
          continue;
        }
        if (!l.disabled)
          return l;
        l = l.previousElementSibling;
      }
      return null;
    }, k = (a, l) => {
      var w;
      const i = Array.from(
        ((w = a.closest(".calendar__days")) == null ? void 0 : w.querySelectorAll(".calendar__day-item:not(.calendar__day-item--empty)")) || []
      ).filter((M) => !M.disabled), v = i.indexOf(a) + l;
      return v < 0 || v >= i.length ? null : i[v];
    };
    return s`
              <button
                tabindex="${e._isFocusable(t) ? 0 : -1}"
                class="calendar__day-item ${x(T)}"
                @click=${() => e._selectDate(t)}
                @mouseover=${() => e._selectRangeOverDate(t)}
                @focus=${() => e._selectRangeOverDate(t)}
                ?disabled=${e._isInactive(t)}
                @keydown="${R}"
              >
                ${t || null}
              </button>
            `;
  })}
        </div>
      </div>
    </div>
    ${e._showMonthSelector ? s`
          <div class="calendar-selector calendar-selector--month">
            <div class="calendar-selector-title">Selecciona un mes</div>
            <div class="calendar-selector-options">
              ${e._generateMonthsOptions()}
            </div>
          </div>
        ` : null}
    ${e._showYearSelector ? s`
          <div class="calendar-selector calendar-selector--year">
            <div
              class="calendar-selector-title calendar-selector-title--years"
            >
              <div class="calendar-selector-title__years">
                ${e._yearsRangeStart} - ${e._yearsRangeEnd}
              </div>
              <div class="calendar-selector-title__actions">
                <${d}
                  hideTooltip
                  variant="primary" 
                  label="Anys anteriors"
                  icon="chevron_left"
                  @click=${e._onYearRangeStepDown}
                ></${d}>
                <${d}
                  hideTooltip
                  variant="primary" 
                  label="Anys posteriors"
                  icon="chevron_right"
                  @click=${e._onYearRangeStepUp}
                ></${d}>
              </div>
            </div>
            <div
              class="calendar-selector-options calendar-selector-options--4col"
            >
              ${e._generateYearsRangeOptions()}
            </div>
          </div>
        ` : null}
    ${e._showTime ? s`
          <div class="dss-datepicker__timepicker">
            <${S}
              .dropdown="${e._timepicker}"
              .customTimeListOptions=${e._customTimeListOptions}
              .minutesRange=${e._minutesRange}
              .minHour=${e._minHour}
              .maxHour=${e._maxHour}
              @onTimepickerChange=${e._onSelectTime}
              .value="${e._timepickerValue}"
            >
              <label slot="label" for="innerTimepicker"
                >${e._timepickerLabel}</label
              >
              <input
                slot="input"
                id="innerTimepicker"
                type="text"
                maxlength="5"
                .value="${e._timepickerValue}"
              />
            </${S}>
          </div>
        ` : null}
    ${(e._showButtons || e._showTime) && !e.standalone ? s`
          <div class="calendar__content calendar__content--buttons">
            <div class="calendar__buttons">
              <${_}
                variant="secondary"
                label=${e._leftLabel}
                @click=${e._onCancel}
              >
              </${_}>
              <${_}
                variant="primary"
                label=${e._rightLabel}

                @click=${e._onAccept}
                ?disabled=${e._validateSelectedDate()}
              >
              </${_}>
            </div>
          </div>
        ` : null}
  </div>
`;
};
export {
  L as template
};
//# sourceMappingURL=calendar.template.js.map
